var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOctagonAlert = function SvgOctagonAlert(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.6H12.009M12 8.4V12M14.9808 3C15.4582 3.0001 15.9159 3.18981 16.2534 3.5274L20.4726 7.7466C20.8102 8.08409 20.9999 8.54185 21 9.0192V14.9808C20.9999 15.4582 20.8102 15.9159 20.4726 16.2534L16.2534 20.4726C15.9159 20.8102 15.4582 20.9999 14.9808 21H9.0192C8.54185 20.9999 8.08409 20.8102 7.7466 20.4726L3.5274 16.2534C3.18981 15.9159 3.0001 15.4582 3 14.9808V9.0192C3.0001 8.54185 3.18981 8.08409 3.5274 7.7466L7.7466 3.5274C8.08409 3.18981 8.54185 3.0001 9.0192 3H14.9808Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOctagonAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "octagon-alert.02ad54bd7471b771ce519dc86d496f60.svg";